import { skipToken, useQuery } from '@tanstack/react-query';
import { useTRPC } from '../utils/trpc.js';

/** What one environment holds that master does not — refetched by the global invalidation after every adopt. */
export const useInbox = (environment: string | null, studio?: string | null) => {
    const trpc = useTRPC();
    const query = useQuery({
        ...trpc.environments.inbox.queryOptions(environment === null ? skipToken : { environment, ...(studio ? { studio } : {}) }),
        meta: { quiet: true },
    });
    return { data: query.data, isLoading: query.isLoading, isError: query.isError, error: query.error, refetch: () => void query.refetch() };
};
